import styles from "./MyAccount.module.css";
import removeFavWhite from "../../images/remove-fav-red.svg";
import whitebid from "../../images/white-bid.svg";
import bitcoin from "../../images/bitcoin.svg";
import db from "../../firebase";
import cld from "../../cloudinary";
import { AdvancedImage } from "@cloudinary/react";
import { useDispatch, useSelector } from "react-redux";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import {
  updateUserFavorites,
  updateUserCollections,
} from "../../store/actions";
import { updateDoc, doc } from "firebase/firestore";
import threeDotsIcon from "../../images/three-dots.svg";
import { useState } from "react";

const SingleCart = ({ img, activeCollection }) => {
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.loggedUser);

  const updateUserFavoritesFn = () => {
    const dataAfterRemoved = loggedUser.favorites.filter(
      (item) => item !== img
    );
    dispatch(updateUserFavorites(dataAfterRemoved));
    updateDoc(doc(db, "user_data", loggedUser.uid), {
      favorites: dataAfterRemoved,
    });
  };

  return (
    <div className={styles.singleCart}>
      {!activeCollection && (
        <img
          src={removeFavWhite}
          className={styles.favIcon}
          onClick={() => updateUserFavoritesFn()}
          alt="Remove Favorite Icon"
        />
      )}
      <DropDown img={img} activeCollection={activeCollection} />
      <AdvancedImage
        cldImg={cld.image(img).resize(thumbnail(300, 400).gravity("faces"))}
        className={styles.singleCartImg}
      />
      {/* <div className={styles.fixedBar}>
        <div>
          <div className={styles.fixedBarDiv}>Highest Bid</div>
          <div>
            <img src={bitcoin} className={styles.bitcoinImg} alt="" />
            <span className={styles.singleCartSpan}>5200 ETH</span>
          </div>
        </div>
        <div>
          <img src={whitebid} className={styles.bidingImg} alt="" />
        </div>
      </div> */}
    </div>
  );
};

const DropDown = ({ img, activeCollection }) => {
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const [collectionList, setCollectionList] = useState(false);
  const loggedUser = useSelector((state) => state.loggedUser);

  const deleteFavorite = async (activeCollection) => {
    let tempActiveCollection = loggedUser.collections.filter(
      (itemm) => itemm.id === activeCollection
    );
    tempActiveCollection[0].content = tempActiveCollection[0].content.filter(
      (itemmm) => itemmm !== img
    );
    let tempCollection = loggedUser.collections.map((item) =>
      item.id === activeCollection ? tempActiveCollection[0] : item
    );
    updateDoc(
      doc(
        db,
        `user_data/${loggedUser.uid}/collections`,
        tempActiveCollection[0].id
      ),
      {
        content: tempActiveCollection[0].content.filter(
          (itemmm) => itemmm !== img
        ),
      }
    );
    dispatch(updateUserCollections(tempCollection));
    alert("Image removed!");
  };

  const addToCollection = (collectionId) => {
    let tempData = loggedUser.collections.filter(
      (item) => item.id === collectionId
    )[0];
    if (tempData.content.find((ele) => ele === img) !== undefined) {
      alert("Error: Already Exixts");
      setCollectionList(false);
      setShowDropdown(false);
      return;
    }
    tempData.content.push(img);
    updateDoc(
      doc(db, `user_data/${loggedUser.uid}/collections`, collectionId),
      {
        content: tempData.content,
      }
    );
    const temppData = loggedUser.collections.map((item) =>
      item.id !== collectionId ? item : tempData
    );
    dispatch(updateUserCollections(temppData));
    alert("Added to Collection");
    setCollectionList(false);
    setShowDropdown(false);
  };

  return (
    <div className={styles.dropDownOuter}>
      <img
        src={threeDotsIcon}
        alt="More Icon"
        className={styles.moreIcon}
        onClick={() => {
          setShowDropdown(!showDropdown);
          setCollectionList(false);
        }}
      />
      {showDropdown && (
        <div className={styles.dropDown}>
          {collectionList ? (
            <>
              {loggedUser.collections.map((collection, index) => (
                <p
                  className={styles.dropDownPara}
                  key={index}
                  onClick={() => addToCollection(collection.id)}
                >
                  {collection.name}
                </p>
              ))}
            </>
          ) : !activeCollection ? (
            <p
              className={styles.dropDownPara}
              onClick={() => {
                if (loggedUser.collections.length === 0) {
                  alert("No collection found!");
                  setShowDropdown(false);
                  return;
                }
                setCollectionList(true);
              }}
            >
              Add to Collection
            </p>
          ) : (
            <p
              className={styles.dropDownPara}
              onClick={() => deleteFavorite(activeCollection)}
            >
              Remove
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleCart;
